// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"21363821","825":"77a354f4"}[chunkId] + ".chunk.js";
};